import React, { useEffect, useState } from "react";
import { Importer } from '../../components/Importer'
import { RecipeImporter } from '../../components/RecipeImporter'
import { ELNStore, updateCategories, updateProducts, updateShops, updateSuppliers } from '../../store'
import { Loader } from '../../helpers/loader';
import ImportShopify from "../../components/ImportShopify";
import { format, sub } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faFileImport, faFlask, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { supabase } from "../../api";
import { displayUser, formatDate, formatDateYMD } from "../../helpers/utils";
import { LogItem } from "../../components/ImportLog";
import Calendar from "react-calendar";



const testEmail = async () => {

    try { 
        await fetch("https://ciemyksmehzdtljwdyot.functions.supabase.co/send-email-via-brevo",
            {
                headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`
                },
                method: "POST",
                mode: 'cors',
                body: JSON.stringify({
                    subject: 'TEST EMAIL',
                    content: '<html><body>Test from <b>ELNB2B</b></body></html>', 
                    recipients: [{ name: 'Test Shop', email: 'matt.woodage@gmail.com' }],
                })
            })

      }
      catch (e) {
          console.error(e)
      }

}


const updateProductsLastOrdered = async () => {

    const { data, error } = await supabase.functions.invoke('update-last-ordered', {
        method: 'POST',
        // optional: headers you require (e.g. secret header)
        headers: {
            // 'x-function-secret': 'your-secret'
        },
        // optional: body if your function expects JSON
        // body: { some: 'payload' }
        });

        if (error) {
        console.error('Function error', error);
        } else {
        console.log('Function response', data);
        }

}

const testBackup = async () => {

    try { 
        await fetch("https://ciemyksmehzdtljwdyot.supabase.co/functions/v1/backup",
            {
                headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`
                },
                method: "POST",
                mode: 'cors',
                body: JSON.stringify({
                    subject: 'NOT USED',
                })
            })

      }
      catch (e) {
          console.error(e)
      }

}


    const listFolder = async (bucket, path = '') => {
        const { data, error } = await supabase
            .storage
            .from(bucket)
            .list(path, {
            limit: 100,
            offset: 0,
            sortBy: { column: 'name', order: 'asc' }
            })

        if (error) {
            console.error(error)
            return []
        }

        return data
    }


    const  buildTree = async (bucket, path = '') => {
        const items = await listFolder(bucket, path)

        const tree = []

        for (const item of items) {
            if (item.id === null) {
            // This is a folder
            const children = await buildTree(bucket, `${path}/${item.name}`)
            tree.push({
                type: 'folder',
                name: item.name,
                children
            })
            } else {
            // This is a file
            tree.push({
                type: 'file',
                path: path,
                name: item.name,
                size: item.metadata?.size || 0
            })
            }
        }

        return tree
    }



export const Admin = () => {

    const [loading, setLoading] = useState(false)
    const [tree, setTree] = useState(undefined)
    const [selectedDate, setSelectedDate] = useState(undefined)
    const [selectedFilepath, setSelectedFilepath] = useState()
    const [log, setLog] = useState(undefined)

    const [testRun, setTestRun] = useState(false)

    const [showArchive, setShowArchive] = useState(false)
    const currentUser = ELNStore.useState(s => s.currentUser);

    const allUsers = ELNStore.useState(s => s.allUsers);

    const buildTime = Number(process.env.REACT_APP_BUILD_TIME)*1000;
    const startTime = Number(process.env.REACT_APP_START_TIME)*1000;

    

    const doSetTestRun = () => {
        setShowArchive(false)
        setTestRun(true)
    }

    const doSetImport = () => {
        setShowArchive(false)
        setTestRun(false)
    }

    const doShowArchive = () => {
        setShowArchive(true)
    }


    const FileButton = ({folder, files}) => {

        const timeStr = folder.slice(0,5)
        const userName = displayUser(allUsers,parseInt(folder.split('-')[1]))

        const csv = files.find(f => f.type === 'file' && f.name.toLowerCase().endsWith('.csv'))
        const json = files.find(f => f.type === 'file' && f.name.toLowerCase() === csv.name.toLowerCase().replace(/\.csv$/i, '.json'))
        
        if (!json) return ''

        const filePath = `${json.path}/${json.name}`

        const doSelect = () => {
            setSelectedFilepath(filePath)
        }
        return <button className={`archive-button ${filePath === selectedFilepath ? 'inv' : ''}`} onClick={doSelect}><FontAwesomeIcon icon={faFileImport} />
            <div>
            <b>{timeStr}</b>&nbsp;&nbsp;<span>{userName}</span><br/><i>{csv.name}</i>
            </div></button>
    }

    useEffect(() => {
        updateSuppliers()
        updateCategories()
        updateShops()
        updateProducts()
    },[])

    useEffect(() => {

        setTree()
        setSelectedFilepath()
        
        const fetchData = async () => {
            //const treeObj = await buildTree('imports','orders')

            //console.log(treeObj)
            //setTree(treeObj)
            setLoading(false)
        }
        if (showArchive) fetchData()


    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[showArchive])
    

    const onSelectDate = async (dt) => {
        setTree()
        setSelectedDate(dt)
        setSelectedFilepath()
        setLoading(true)
        const treeObj = await buildTree('imports',`orders/${formatDateYMD(new Date(dt))}`)
        setTree(treeObj)
        setLoading(false)

    }

    useEffect(() => {

        const fetchFile = async () => {

            const { data, error } = await supabase
                .storage
                .from('imports')
                .download(selectedFilepath)

            if (error) {
                console.error(error)
                return
            }

            const text = await data.text()
            const json = JSON.parse(text)

            if (json) {
                setLog(json)
            }
        }
        if (selectedFilepath) fetchFile()
    }, [selectedFilepath])

    if (!currentUser) return <Loader />


    return (
    <div className='outer center'>
        
        <h1>Import from PW</h1>

        {currentUser.p_admin>=2 &&

        <>
        <ul className='button-list'>

                <li className={showArchive ? 'selected' : ''}><button onClick={doShowArchive}><FontAwesomeIcon icon={faCalendar} />&nbsp;PREVIOUS IMPORTS</button></li>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                <li className={testRun && !showArchive ? 'selected' : ''}><button onClick={doSetTestRun}><FontAwesomeIcon icon={faFlask} />&nbsp;TEST RUN</button></li>
                <li className={!testRun && !showArchive ? 'selected' : ''}><button onClick={doSetImport}><FontAwesomeIcon icon={faFileImport} />&nbsp;IMPORT &amp; SAVE CHANGES</button></li>
              </ul>
        

        
        {showArchive && 
        
        <div className='archive-wrapper'>
            <div className='archive-menu'>
            
            <Calendar
                onChange={onSelectDate}
                showNeighboringMonth={false}
                next2Label={null}
                date={new Date()}
                prev2Label={null}
                minDate={sub(new Date(), {months: 1})}
                maxDate={new Date()}
            />    

            <br/>
            {loading && <Loader />}
            {!loading && selectedDate && <h2>{formatDate(selectedDate)}</h2>}
            {tree && tree.map(ftime => {
                            if (ftime.type === 'file') return ''

                            return (
                                <FileButton folder={ftime.name} files={ftime.children} />
                            )
                        })
      
                
}
    
            </div>
            <div className='archive-window'>
            {log && log.length ? log.map(l => <LogItem item={l} products={[]} />) : ''}
            </div>
        </div>}



        {!showArchive && <>
        <Importer currentUser={currentUser} testRun={testRun} />

        <br/><br/><br/><br/>

        <RecipeImporter currentUser={currentUser} testRun={testRun} />

        <br/><br/><br/><br/>

        <ImportShopify currentUser={currentUser} testRun={testRun} />

   
        </>}

        <br/><br/><br/>


        {currentUser.superadmin &&
         <div>
            <br/><br/><br/><br/>
            <button onClick={updateProductsLastOrdered}>Update products</button>
            <br/><br/><br/><br/>
            <button onClick={testBackup}>Test Backup</button>
            <br/><br/>
            {1 === 2 && <button onClick={testEmail}>Test Email</button>}

            env: {process.env.REACT_APP_PUBLIC_ENV}<br/>
            started: {startTime && format(startTime,'EEE d LLL HH:mm')}<br/>
            built: {buildTime ? format(buildTime,'EEE d LLL HH:mm') : '?'}<br/>
            <br/>
            </div>}
            
        </>}

    </div>
    )
}

export default Admin;